import * as React from 'react'

export const matchContext = React.createContext<string | undefined>(undefined)
